module.exports = __webpack_public_path__ + "static/img/card.6f26041d.jpg";